export default __webpack_public_path__ + "static/media/calendar-date.5a60ec3d.svg";